/*=====================================
    ForgetPwdDialog

    Author: Ac
    CreateTime: 2018 / 08 / 17
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, {
    useState,
} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle, Colors, DialogStyle } from 'stylecomponents';
import GLOBAL from 'nonnglobal';

/*--------------------------
    Styled
--------------------------*/
const Title = styled.div`
    font-size: 23px;
    color: #4A4A4A;
    font-weight: 600;
    text-align: center;
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid #D9D9D9;
`;
const RowTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: #232423;
    margin-bottom: 10px;
`;
const Input = GlobalStyle.BasicInput.extend`
`;
const ActionBtn = styled.div`
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 2px;
    background-color: ${Colors.MAIN_COLOR};
    color: #FFF;
    font-size: 16px;
    margin: 17px 0 16px;
    cursor: pointer;
    opacity: ${({ disable }) => disable ? 0.5 : 1};

    ${GlobalStyle.Spin} {
        margin-right: 10px;
    }
`;
const Guide = styled.div`
    text-align: center;
    font-size: 14px;
    color: #4A4A4A;
`;

/**
 * 忘記帳號
 * @author Ac
 * @time 2020 / 08 / 10
 */
const ForgotAccountView = props => {

    const [isUseIdNumber, setIsUseIdNumber] = useState(!!GLOBAL.getRandomInt(0, 1)) // 0 ~ 1, 1 = 身分證, 0 = 手機
    const [value, setValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [validateResult, setValidateResult] = useState(null);
    const [email, setEmail] = useState('');
    
    const forgetAccount = () => {

        if (isLoading) {
            return;
        }

        let payload = {},
            errorMsg = '';

        if (isUseIdNumber) {

            const {
                result,
                message,
            } = GLOBAL.chkIdnumber(value);

            result
                ? payload = { idNumber: value }
                : errorMsg = message;
        } else {
            GLOBAL.chkMobile(value)
                ? payload = { mobilePhone: value }
                : errorMsg = '手機號碼輸入錯誤！';
        }

        if (errorMsg) {
            props.webActions.openAlertDialog({
                title: '輸入錯誤',
                description: errorMsg,
            });
            return;
        }

        setIsLoading(true);

        props.memberActions.forgetAccount(
            payload
        ).then(result => {
            setIsLoading(false);
            setValue('');
            setValidateResult(result);
        }).catch(error => {

            setIsLoading(false);
            setValue('');
            // 隨機重選輸入類型
            setIsUseIdNumber(!!GLOBAL.getRandomInt(0, 1));

            props.webActions.openAlertDialog({
                title: '發生錯誤',
                description: error && error.message
                    ? error.message
                    : '發生無法預期的錯誤，請聯絡客服或稍後再試',
            });
        });
    };

    const sendAccountEmail = () => {

        if (isLoading) {
            return;
        }

        if (!GLOBAL.isEmail(email)) {
            props.webActions.openAlertDialog({
                title: '輸入錯誤',
                description: '請輸入正確的Email格式！',
            });
            return;
        }

        setIsLoading(true);

        props.memberActions.sendAccountEmail({
            memberId: validateResult.memberid,
            token: validateResult.token,
            email,
        }).then(() => {

            setIsLoading(false);
            setValidateResult(null);
            setEmail('');

            props.webActions.openAlertDialog({
                title: '驗證成功',
                description: '帳號資訊已發送至您的信箱，請至您的信箱查看',
            });
        }).catch(error => {

            setIsLoading(false);

            let errorMsg = '';

            if (error && error.code === 'error.account.accountNotExist') {
                errorMsg = '您輸入的信箱不正確';
            } else if (error && error.message) {
                errorMsg = error.message;
            } else {
                errorMsg = '發生無法預期的錯誤，請聯絡客服或稍後再試';
            }

            props.webActions.openAlertDialog({
                title: '發生錯誤',
                description: errorMsg,
            });
        });
    };

    const hideDialog = () => {
        props.webActions.closeForgotAccountDialog();
    };
    
    return (
        <DialogStyle.Content
            // style props
            maxWidth="350px"
            margin="200px auto auto auto"
            padding="30px"
            borderRadius="3px"
            // dialog props
            visible
            animation="zoom"
            maskAnimation="fade"
            closable={false}
            className="signup-modal"
            onClose={hideDialog}
        >

            <DialogStyle.CloseButton onClick={hideDialog}>
                <i className="zmdi zmdi-close"></i>
            </DialogStyle.CloseButton>
            <Title>忘記帳號</Title>

            {validateResult
                ? (
                    <React.Fragment>
                        <RowTitle>
                            會員信箱
                        </RowTitle>
                        <Input
                            placeholder='請輸入會員信箱'
                            type='text'
                            value={email}
                            onChange={event => setEmail(event.target.value)}
                        />
                        <ActionBtn
                            onClick={sendAccountEmail}
                            disable={isLoading}
                        >
                            {isLoading && <GlobalStyle.Spin color='#FFF' />}
                            送出
                        </ActionBtn>

                        <Guide>
                            請輸入會員信箱，系統將會把帳號發送至您的信箱！
                        </Guide>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <RowTitle>
                            {isUseIdNumber ? '身分證字號' : '手機號碼'}
                        </RowTitle>
                        <Input
                            placeholder={isUseIdNumber ? '請輸入身分證' : '請輸入手機號碼'}
                            type='text'
                            value={value}
                            onChange={event => setValue(event.target.value)}
                        />
                        <ActionBtn
                            onClick={forgetAccount}
                            disable={isLoading}
                        >
                            {isLoading && <GlobalStyle.Spin color='#FFF' />}
                            送出
                        </ActionBtn>
                    </React.Fragment>
                )
            }
         </DialogStyle.Content>
    );
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        memberActions: bindActionCreators(actionCreators.memberActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(null, mapActionToProps)(ForgotAccountView);